// extracted by mini-css-extract-plugin
module.exports = {"bg":"T4Cnv","inlineContent":"_2Etjm","pageWrapper":"_30wY_","root":"_3ZKIF"};